import React from 'react';

export default function BackArrow () {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24.887" height="24.887" viewBox="0 0 24.887 43.427">
      <path id="Path_6347" data-name="Path 6347" d="M433.618,115.134,412.863,93.093l20.785-21.386,4.071,3.956-17,17.492,17.033,18.088Z" transform="translate(-412.863 -71.707)" fill="#656464" />
    </svg>
  )
}
